angular.module('picmonic-common')
    .directive("palifeBlock", [function(){
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/palife-block.html'
        };
    }]);